// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__wvE99","body":"Toast_body__pBlw9"};